import { Card, Header } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import DECISION from '../../../constants/common/decision';

interface AutorisationPanelProps {
	decision: number;
	montant: number;
	total: number;
}

const AutorisationPanel = ({
	decision,
	montant,
	total,
}: AutorisationPanelProps) => (
	<Card fluid>
		<Card.Content>
			<Card.Meta
				content={`${decision === DECISION.AP ? 'APCP' : 'AECP'} Actives`}
			/>
			<br />
			<Card.Header>
				<Header
					content={formatMontant(montant)}
					subheader={`${total} autorisations`}
				/>
			</Card.Header>
		</Card.Content>
	</Card>
);

export default AutorisationPanel;
